import BotaoPrincipal from "@/components/BotaoPrincipal";
import BotaoSecundario from "@/components/BotaoSecundario";
import BotaoText from "@/components/BotaoText";
import TituloTelaAcao from "@/components/TituloTelaAcao";
import { ehAreaParceiro } from "@/services/ambiente";
import { get, post } from "@/services/api";
import { validaCpfCnpj } from "@/services/document";
import { trackKonduto } from "@/services/konduto";
import {
  apenasNumeros,
  formatMonetario,
  formatPhoneNumber,
  validaNumeroTelefone,
  validarEmail,
} from "@/services/utils";
import {
  activeSpinner,
  cancelSpinner,
  setInfoDialog,
} from "@/store/reducers/geral";
import AddIcon from "@mui/icons-material/Add";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ShareIcon from "@mui/icons-material/Share";
import Alert from "@mui/material/Alert";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid2";
import Typography from "@mui/material/Typography";
import { useFormik } from "formik";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router";
import * as Yup from "yup";
import { formataValorSimulador } from "../../../../services/utils";
import { getItemsRequestBills } from "../simulatorUtils";
import DialogTipoItemPagamento from "./DialogTipoItemPagamento";
import ItemPagamentoBoletos from "./ItemPagamentoBoletos";
import ItemPagamentoIpvas from "./ItemPagamentoIpvas";
import ItemPagamentoPix from "./ItemPagamentoPix";

export default function EtapaItemsPagamento({
  permiteVoltarEtapa,
  salvarSimulacaoParaLink,
  setNavegarEtapa,
  dadosUsuario,
  abrirLinkPagamento,
  avancarParaAutenticacao,
}) {
  const dispatch = useDispatch();
  const params = useParams();
  const [carregar, setCarregar] = useState(false);
  const [infoDialogTipoItemPagamento, setInfoDialogTipoItemPagamento] =
    useState({ open: false });
  const billValue = dadosUsuario.billValue;

  const Schema = Yup.object().shape({
    expireDate: Yup.string(),
  });
  const validaItemsPagamento = (values) => {
    let totalItemsPagamento = 0;

    for (let i = 0; i < values.pixs.length; i++) {
      let pix = values.pixs[i];
      if (pix.pixKey) {
        pix.pixKey = pix.pixKey.trim().toLowerCase();
        if (pix.pixType === "CpfCnpj") {
          const pixKey = apenasNumeros(pix.pixKey);
          if (pixKey.length !== 11 && pixKey.length !== 14) {
            return `A chave PIX "${pix.pixKey}" não é válida!`;
          }

          if (!validaCpfCnpj(pixKey)) {
            return `A chave PIX "${pix.pixKey}" não é válida!`;
          }
        }
        if (pix.pixType === "Telefone") {
          const pixKey = apenasNumeros(pix.pixKey);
          if (pixKey.length < 8 || pixKey.length > 12) {
            return `A chave PIX "${pix.pixKey}" não é válida!`;
          }

          const formataNumero = formatPhoneNumber(pix.pixKey);
          if (!validaNumeroTelefone(formataNumero)) {
            return `A chave PIX "${formataNumero}" não é válida!`;
          }
        }
        if (pix.pixType === "Email") {
          const pixKey = pix.pixKey;
          if (!validarEmail(pixKey)) {
            return `A chave PIX e-mail "${pix.pixKey}" não é válida!`;
          }

          if (dadosUsuario.amount) {
            return `Informe o valor para o PIX ${pix.pixKey}!`;
          }
        }
      }
      totalItemsPagamento += pix.amount;
    }

    for (let i = 0; i < values.boletos.length; i++) {
      let boleto = values.boletos[i];
      const barcode = apenasNumeros(boleto.barcode);
      if (barcode.length !== 47 && barcode.length !== 48) {
        return `O boleto com código "${boleto.barcode}" não é válido!`;
      }
      if (!boleto.amount) {
        return `Informe o valor do boleto ${boleto.barcode}!`;
      }
      totalItemsPagamento += boleto.amount;
    }

    for (let i = 0; i < values.ipvas.length; i++) {
      let ipva = values.ipvas[i];
      if (!ipva.car_plate) {
        return `Informe a placa do veículo!`;
      }
      if (!ipva.renavam) {
        return `Informe o Renavan do veículo!`;
      }
      if (!ipva.amount) {
        return `Informe o valor dos débitos do veículo ${ipva.car_plate}!`;
      }
      totalItemsPagamento += ipva.amount;
    }
    if (totalItemsPagamento !== Number(billValue)) {
      return `O valor informado nos items (${formatMonetario(
        totalItemsPagamento
      )}) é diferente do valor simulado na operação (${formatMonetario(
        billValue
      )}). Para alterar o valor você deve voltar a etapa anterior e simular com o valor correto!`;
    }
    return null;
  };

  const salvar = (values) => {
    var promise = new Promise(async (resolve, reject) => {
      try {
        const items = getItemsRequestBills(values);
        dispatch(activeSpinner());

        const cadastro = {
          items: items,
          token: dadosUsuario.token,
          idRequest: dadosUsuario.idRequest,
        };

        if (!!dadosUsuario.isB2c) {
          cadastro.isB2c = dadosUsuario.isB2c;
          cadastro.name = dadosUsuario.name;
          cadastro.email = dadosUsuario.email;
        }

        const result = await post("public/requests-bills", cadastro);
        dispatch(cancelSpinner());
        if (result.error) {
          dispatch(setInfoDialog({ open: true, descricao: result.error }));
          reject(result.error);
          return;
        }
        resolve();
      } catch (e) {
        console.log(e);
        dispatch(
          setInfoDialog({ open: true, descricao: "Ocorreu um erro ao salvar" })
        );
        dispatch(cancelSpinner());
        reject(e);
      }
    });
    return promise;
  };

  const itemPadraoPix = useMemo(() => {
    return {
      id: 1,
      amount: "",
      pixKey: "",
      pixType: "CpfCnpj",
      beneficiary: "",
      billType: "PIX",
    };
  }, []);

  const itemPadraoBoleto = useMemo(() => {
    return {
      id: 1,
      barcode: "",
      amount: "",
      billType: "BILLET",
    };
  }, []);
  const itemPadraoIPVA = useMemo(() => {
    return {
      id: 1,
      barcode: "",
      amount: "",
      pixType: "CpfCnpj",
      beneficiary: "",
      car_plate: "",
      renavam: "",
      billType: "IPVA",
    };
  }, []);

  const formik = useFormik({
    initialValues: {
      pixs: [],
      ipvas: [],
      boletos: [],
    },
    validationSchema: Schema,
    onSubmit: async (values) => {
      if (!boletoOuPixForamInformados()) {
        dispatch(
          setInfoDialog({
            open: true,
            descricao: "Informe os dados de pelo menos um boleto ou PIX!",
          })
        );
        return;
      }
      const mensagemErro = validaItemsPagamento(values);
      if (mensagemErro) {
        dispatch(setInfoDialog({ open: true, descricao: mensagemErro }));
        return;
      }
      await salvar(values);
      avancarParaAutenticacao();
    },
  });
  const { setFieldValue } = formik;

  useEffect(() => {
    setCarregar(true);
  }, []);

  const adicionarBoleto = useCallback(() => {
    const boletos = formik.values.boletos;
    const itemAdd = { ...itemPadraoBoleto };
    const items = getItemsRequestBills(formik.values);
    if (items.length === 0) {
      itemAdd.amount = billValue;
    }
    itemAdd.id = boletos.length + 1;
    boletos.push(itemAdd);
    setFieldValue("boletos", boletos);
  }, [setFieldValue, formik.values, itemPadraoBoleto, billValue]);

  const adicionarIPVA = useCallback(() => {
    const ipvas = formik.values.ipvas;
    const itemAdd = { ...itemPadraoIPVA };
    const items = getItemsRequestBills(formik.values);
    if (items.length === 0) {
      itemAdd.amount = billValue;
    }
    itemAdd.id = ipvas.length + 1;
    ipvas.push(itemAdd);
    setFieldValue("ipvas", ipvas);
  }, [setFieldValue, formik.values, itemPadraoIPVA, billValue]);

  const adicionarPix = useCallback(() => {
    const pixs = formik.values.pixs;
    const itemAdd = { ...itemPadraoPix };
    itemAdd.id = pixs.length + 1;

    const items = getItemsRequestBills(formik.values);
    if (items.length === 0) {
      itemAdd.amount = billValue;
    }

    pixs.push(itemAdd);
    setFieldValue("pixs", pixs);
  }, [setFieldValue, formik.values, itemPadraoPix, billValue]);

  const adicionarBoletoOuPix = useCallback(() => {
    const items = getItemsRequestBills(formik.values);
    if (items.length === 10) {
      dispatch(
        setInfoDialog({
          open: true,
          descricao:
            "Você pode adicionar no máximo 10 itens. Caso necessite, faça outra operação com os novos itens.",
        })
      );
      return;
    }
    setInfoDialogTipoItemPagamento({
      open: true,
      selecionar: (tipo) => {
        if (tipo === "boleto") {
          adicionarBoleto();
          window.location.href = "#inicio-items-pagamento";
        } else if (tipo === "IPVA") {
          adicionarIPVA();
        } else {
          adicionarPix();
        }
      },
    });
  }, [adicionarBoleto, dispatch, formik.values, adicionarIPVA, adicionarPix]);

  useEffect(() => {
    const getBills = async () => {
      try {
        dispatch(activeSpinner());
        const bills = await get(
          `public/requests-bills/${params.idRequest}/${params.tokenRequest}`
        );
        dispatch(cancelSpinner());
        const pixs = [];
        const boletos = [];
        const ipvas = [];
        bills.forEach((bill) => {
          bill.amount = formataValorSimulador(bill.amount || 0);
          if (bill.billType === "IPVA") {
            const placaData = bill.barcode
              .split("PLACA:")[1]
              .split(" - ")[0]
              .trim();
            const renavamData = bill.barcode.split("RENAVAM:")[1].trim();
            ipvas.push({
              car_plate: placaData,
              renavam: renavamData,
            });
          } else if (bill.billType === "PIX") {
            pixs.push(bill);
          } else {
            boletos.push(bill);
          }
        });

        formik.setFieldValue("boletos", boletos);
        formik.setFieldValue("ipvas", ipvas);
        formik.setFieldValue("pixs", pixs);
        if (boletos.length === 0 && ipvas.length === 0 && pixs.length === 0) {
          adicionarBoletoOuPix();
        }
      } catch (e) {
        console.log(e);
        setInfoDialog({
          open: true,
          descricao:
            'Nâo foi possível carregar suas credenciais. Por favor tente novamente!".',
        });
      }
    };

    if (!carregar) {
      return;
    }
    setCarregar(false);
    trackKonduto("product", ehAreaParceiro());
    getBills();
  }, [
    carregar,
    formik,
    params.idRequest,
    params.tokenRequest,
    adicionarBoletoOuPix,
    itemPadraoPix,
    itemPadraoBoleto,
    dispatch,
  ]);

  const itemBoletoOuPixFoiAdicionado = () => {
    const boletos = formik.values.boletos.concat(
      formik.values.pixs,
      formik.values.ipvas
    );
    return boletos.length > 0;
  };

  const boletoOuPixForamInformados = () => {
    const boletos = formik.values.boletos.concat(
      formik.values.pixs,
      formik.values.ipvas
    );
    for (let i = 0; i < boletos.length; i++) {
      let boleto = boletos[i];
      if (
        boleto.barcode ||
        boleto.pixKey ||
        (boleto.car_plate && boleto.renavam)
      ) {
        return true;
      }
    }
    return false;
  };

  const criarLink = async () => {
    const dadosSalvos = await salvarSimulacaoParaLink(dadosUsuario);
    if (boletoOuPixForamInformados()) {
      await salvar(formik.values);
    }
    abrirLinkPagamento(dadosSalvos);
  };

  return (
    <>
      <Container maxWidth="md" id="inicio-items-pagamento">
        <form onSubmit={formik.handleSubmit}>
          <>
            <Grid
              container
              spacing={2}
              justifyContent="center"
              sx={{ paddingBottom: "1rem" }}>
              <Grid
                item
                size={12}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}>
                <Grid
                  item
                  size={12}
                  sx={{
                    textAlign: "center",
                    width: { xs: "100%", sm: "60%" },
                    mt: 2,
                    ml: 2,
                  }}>
                  <TituloTelaAcao>
                    Valor total dos boletos ou PIX:{" "}
                    {formatMonetario(dadosUsuario.billValue)}
                  </TituloTelaAcao>
                </Grid>
              </Grid>

              <ItemPagamentoBoletos {...{ formik }} />
              <ItemPagamentoIpvas {...{ formik }} />
              <ItemPagamentoPix {...{ formik }} />

              <Grid item size={12} align="center">
                <BotaoSecundario
                  startIcon={<AddIcon />}
                  onClick={() => {
                    adicionarBoletoOuPix();
                  }}>
                  {!itemBoletoOuPixFoiAdicionado()
                    ? "ADICIONAR BOLETO, PIX OU IPVA"
                    : "ADICIONAR OUTRO BOLETO, PIX OU IPVA"}
                </BotaoSecundario>
              </Grid>
              <Grid container spacing={3} sx={{ mt: 1, ml: 1 }}>
                <Grid item size={6}>
                  {permiteVoltarEtapa() && (
                    <Box>
                      <BotaoText
                        onClick={() => {
                          setNavegarEtapa(2);
                        }}>
                        VOLTAR
                      </BotaoText>
                    </Box>
                  )}
                </Grid>

                <Grid item size={6}>
                  <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                    <BotaoPrincipal
                      endIcon={<ArrowForwardIcon />}
                      id="btn-avancar-items-pagamento"
                      type="submit">
                      AVANÇAR
                    </BotaoPrincipal>
                  </Box>
                </Grid>
                <Grid item size={12}>
                  <Alert severity="warning" sx={{ mt: 1 }}>
                    <Typography>
                      Nosso prazo médio é de apenas <b>algumas horas</b>, porém
                      pode levar até <b>2 dias úteis</b> para o débito ser
                      quitado!
                    </Typography>
                  </Alert>
                </Grid>
              </Grid>
              <Grid item size={12} align="center" sx={{ mb: 1 }}>
                <BotaoText
                  startIcon={<ShareIcon />}
                  onClick={() => {
                    criarLink();
                  }}>
                  COMPARTILHAR
                </BotaoText>
              </Grid>
            </Grid>
          </>
        </form>
      </Container>
      {infoDialogTipoItemPagamento?.open && (
        <DialogTipoItemPagamento
          {...{ infoDialogTipoItemPagamento, setInfoDialogTipoItemPagamento }}
        />
      )}
    </>
  );
}
